import classes from "./index.module.scss";
import Mailchimp from "../../../commons/Mailchimp";

export default function Push() {
  const mailChimpID = "b0bf909d89";
  const mailChimpBtnText = "GET PDF";
  return (
    <section className={classes.section}>
      <div className={classes.container}>
        <div className={classes.body}>
          <h2 className={classes.title}>
            How to <span>push your business to a new level </span>without heavy
            investments
          </h2>
          <Mailchimp id={mailChimpID} btnText={mailChimpBtnText} />
        </div>
      </div>
    </section>
  );
}
